import { Snack } from "@tblabs/truffle";
import { OrdersManager } from "../Services/Storage/OrdersManager";
import { StepFactory } from "../Services/StepFactory";
import { TicketToOrderConverter } from "../Services/Storage/TicketToOrderConverter";
import { ShopContent } from "../Shop/ShopContent";
import { Dataset } from "@tblabs/storage";
import { Page } from "./Page";
import { TicketForm } from "./TicketForm";
import { TicketData } from "./TicketData";
import { PrimaryButton } from "../Components/Utils/PrimaryButton";
import { PaymentForm } from "../Models/Payment/PaymentForm";
import { BitcoinPriceProvider } from "../Steps/Payment/Services/BitcoinPriceProvider";


export class OrderGeneratorPage extends Page
{
    constructor(
        private _manager: OrdersManager,
        private _stepsFactory: StepFactory,
        private _shop: Dataset<ShopContent>,
        private orderIdToRegenerate?: string)
    {
        super("Generator zamówień");
        this.Padding(16)

        this.Content(async (body) => 
        {
            const shop = await this._shop.GetOne("Shop");

            const ticketData = new TicketData();

            if (this.orderIdToRegenerate)
            {
                const order = await this._manager.GetOne(this.orderIdToRegenerate);

                ticketData.FromTicket(order.Meta.Ticket);
            }

            this.Append(
                new TicketForm(shop, ticketData),
                new PrimaryButton("Dodaj do zamówień", async (btn) =>
                {
                    btn.Disabled();

                    const ticket = ticketData.ToTicket();

                    let btcValueInPln = -1;
                    if (ticket.BasketPaymentForm == PaymentForm.Crypto)
                    {
                        const _bitcoinPriceProvider = new BitcoinPriceProvider();
                        await _bitcoinPriceProvider.Update();
                        btcValueInPln = _bitcoinPriceProvider?.BtcValueInPln.value ?? (-1);
                    }

                    const order = new TicketToOrderConverter(this._stepsFactory).Convert(ticket, btcValueInPln);
                  
                    await this._manager.Add(order);

                    new Snack("Wygenerowano nowe zamówienie #" + order.ShortId, orderIdToRegenerate ? `Na bazie zamówienia #${this.orderIdToRegenerate}` : "", { autoCloseTimeout: 0 });
                }).MarginTop(16)
            );
        });
    }
}
